
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

// import * as api from "../constant/API";
import Utils from "../constant/Utils";

const SportReference = () => {

    const roleId = localStorage.getItem('RoleId');
    const userId = localStorage.getItem('UserId');

    const baseurl = "https://www.tenvicsports.com/TenvicBase/Reference/";

    const [searchInput, setSearchInput] = useState("");
    const [sportId, setSportId] = useState("");
    const [upSportId, setUpSportId] = useState("");
    const [documentType, setDocumentType] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [sportList, setSportList] = useState([]);
    const [refLinksList, setRefLinksList] = useState([]);
    const [showTable, setShowTable] = useState(false);

    useEffect(() => {
        getReferenceList();
    }, [])

    function getReferenceList() {
        const getReferenceSport = api.ReferenceSport //+ "?userId=" + userId + "&roleId=" + roleId;
        fetch(getReferenceSport, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.error == true) {
                    if (sprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (sprtResult.data != null) {
                        setSportList(sprtResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log('Failed to fetch sport list', error);
            })
    }

    function getRefLinks() {
        const refLinks = api.ReferenceLink + '/' + sportId //"?sportId=" + sportId;
        fetch(refLinks, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((refResponse) => refResponse.json())
            .then((refResult) => {
                if (refResult.error == true) {
                    if (refResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (refResult.data != null) {
                        setRefLinksList(refResult.data)
                    }

                    setShowTable(true)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the links", error);
            })
    }

    function uploadDoc() {
        const formData = new FormData();

    }

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-md-12">
                                                            <div className="row col-md-12 court-sortby sortbyset">
                                                                <div className="col-lg-4">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>Sport</h6></label>
                                                                        <Select
                                                                            value={sportList.find(sprt => sprt.sportId === sportId) ? {
                                                                                value: sportId,
                                                                                label: sportList.find(sprt => sprt.sportId === sportId).sportName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setSportId(e.value);
                                                                            }}
                                                                            options={sportList.map(sprt => ({
                                                                                value: sprt.sportId,
                                                                                label: sprt.sportName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3 col-md-12 col-sm-12">
                                                                    <Link
                                                                        className="btn btn-secondary"
                                                                        to="#"
                                                                        style={{ padding: "10px 40px", marginTop: "1.5rem" }}
                                                                        // data-bs-toggle="modal"
                                                                        // data-bs-target="#create-batch"
                                                                        onClick={getRefLinks}
                                                                    >
                                                                        <span>
                                                                            <i className="fas fa-eye" />
                                                                        </span>
                                                                        Show
                                                                    </Link>
                                                                </div>
                                                                {roleId == '1' || roleId == '3' ? (
                                                                    <>
                                                                        <div className="col-lg-5 col-md-12 col-sm-12 table-search-top">
                                                                            <Link
                                                                                className="btn btn-secondary"
                                                                                to="add-students"
                                                                                style={{ padding: "10px 40px", marginTop: "1.5rem" }}
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#upload-document"
                                                                            >
                                                                                <span>
                                                                                    <i className="fas fa-file-upload" />
                                                                                </span>
                                                                                Upload
                                                                            </Link>
                                                                        </div>
                                                                    </>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        {showTable && (
                                                            <>
                                                                <div className="row">
                                                                    <div className="sortby-section mt-5">
                                                                        <div className="row">
                                                                            {Array.isArray(refLinksList) && refLinksList.map((lnk, index) => (
                                                                                <div className="col-md-4 text-center mb-4" key={index}>
                                                                                    <a href={baseurl + lnk.sportName + "/" + lnk.referenceFilename} target="_blank" rel="noopener noreferrer" className="icon-link">
                                                                                        <div className="icon-container">
                                                                                            <i className="fas fa-file-lines fa-5x me-1" style={{ color: "#1eb0d5" }}></i>
                                                                                            <h6>{lnk.sportName} - {lnk.referenceType}</h6>
                                                                                        </div>
                                                                                    </a>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Upload Document */}
            <div className="modal custom-modal fade payment-modal"
                id="upload-document"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    <i className="fas fa-key" />
                                    Upload Document
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="col-md-12">
                                    <div className="input-space">
                                        <label className="form-label">Sport</label>
                                        <Select
                                            value={sportList.find(sprt => sprt.sportId === upSportId) ? {
                                                value: upSportId,
                                                label: sportList.find(sprt => sprt.sportId === upSportId).sportName
                                            } : null}
                                            onChange={(e) => {
                                                setUpSportId(e.value);
                                            }}
                                            options={sportList.map(sprt => ({
                                                value: sprt.sportId,
                                                label: sprt.sportName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-space">
                                        <label className="form-label">Document Type</label>
                                        <Select
                                            options={[
                                                { value: "Assessment Template", label: "Assessment Template" },
                                                { value: "Coaching Manual", label: "Coaching Manual" },
                                                { value: "Session Planner", label: "Session Planner" }
                                            ]}
                                            onChange={(e) => {
                                                setDocumentType(e.value)
                                            }}
                                        ></Select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-space">
                                        <label className="form-label" style={{ marginBottom: "10px", display: "block" }}>Upload Document</label>
                                        <input
                                            type="file"
                                            id="file-upload"
                                            // accept="application/pdf"
                                            onChange={handleFileChange}
                                            style={{
                                                display: "none",
                                            }}
                                        />
                                        <label
                                            htmlFor="file-upload"
                                            style={{
                                                padding: "10px 20px",
                                                border: "1px solid hsl(0, 0%, 80%)",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {selectedFile ? selectedFile.name : "Select File (pdf)"}
                                        </label>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <Link to="#" className="btn btn-secondary close" onClick={uploadDoc} data-bs-dismiss="modal" aria-label="Close">
                                    <i className="fas fa-file-upload" />
                                    Upload
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Upload Document */}
        </>
    );
};

export default SportReference;